import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import dbsLogo from '~/assets/logos/dbs-logo.png';
import Image from '~/components/Image/Image';
import { Paragraph, Text } from '~/components/Typo/Typo';
import { FontWeight } from '~/theme/constants';
import emojiSad from '~/assets/icons/emoji.png';

import './Login.scss';

const Login: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="login">
      <Row justify="center">
        <Col lg={8} className="login-first-part">
          <Image className="logo-part" image={dbsLogo} />
          <Paragraph className="error-wrapper">
            <Text className="error-code-part" weight={FontWeight.MEDIUM}>
              403.
            </Text>
            <Text className="error-statusText-part" weight={FontWeight.LIGHT}>
              {t('forbiddenPage:accessForbidden')}
            </Text>
          </Paragraph>
          <Paragraph className="error-content">{t('forbiddenPage:yourPaymentSessionExpired')}</Paragraph>
        </Col>
        <Col lg={8} className="login-second-part">
          <Image className="icon" image={emojiSad} />
        </Col>
      </Row>
    </div>
  );
};

export default Login;
